import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'project-table-planner-name-badge-mode';

export type PlannerNameBadgeMode = 'all' | 'danger_only' | 'off';

export const PLANNER_NAME_BADGE_MODES_ORDER: PlannerNameBadgeMode[] = ['all', 'danger_only', 'off'];

export const PLANNER_NAME_BADGE_MODE_LABELS: Record<PlannerNameBadgeMode, string> = {
  all: 'Все',
  danger_only: 'Только опасные',
  off: 'Выключить все',
};

function loadFromStorage(): PlannerNameBadgeMode {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return 'all';
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed === 'string' && PLANNER_NAME_BADGE_MODES_ORDER.includes(parsed as PlannerNameBadgeMode)) {
      return parsed as PlannerNameBadgeMode;
    }
    return 'all';
  } catch {
    return 'all';
  }
}

function saveToStorage(value: PlannerNameBadgeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // ignore
  }
}

export function usePlannerNameBadgeMode(): {
  plannerNameBadgeMode: PlannerNameBadgeMode;
  setPlannerNameBadgeMode: (mode: PlannerNameBadgeMode) => void;
} {
  const [plannerNameBadgeMode, setPlannerNameBadgeModeState] = useState<PlannerNameBadgeMode>(loadFromStorage);

  useEffect(() => {
    saveToStorage(plannerNameBadgeMode);
  }, [plannerNameBadgeMode]);

  const setPlannerNameBadgeMode = useCallback((mode: PlannerNameBadgeMode) => {
    setPlannerNameBadgeModeState(mode);
  }, []);

  return { plannerNameBadgeMode, setPlannerNameBadgeMode };
}
